import type { RouteRecordRaw } from 'vue-router';
import { jobIsAvailableRouteGuard } from './routeGuards';

export const JOB_UNAVAILABLE = 'job-unavailable';
export const STUDIO_ACCESS_CODE = 'studio-access-code';
export const SUBJECT_SEARCH = 'job-subject-form';
export const SUBJECTS_GALLERY = 'job-subjectsgallery';
export const CONFIRM_CART = 'confirm-cart';
export const DIGITAL_DOWNLOAD = 'digital-download';
export const AUTO_STUDIO_ACCESS_CODE = 'auto-studio-access-code';
/** Consumer-derived gallery only: "who are you ordering for?" (step 1) and its create-new leaf. */
export const CONSUMER_GALLERY_ROSTER = 'consumer-gallery-roster';
export const CONSUMER_GALLERY_NEW_SUBJECT = 'consumer-gallery-new-subject';
/** Landing for the link in a consumer's "finish your order" email; opens the cart then moves to the cart page. */
export const CONSUMER_REVIEW_LINK = 'consumer-review-link';

export const routes: RouteRecordRaw[] = [
  {
    path: '',
    alias: '/:studioSlug',
    name: STUDIO_ACCESS_CODE,
    component: () => import('./pages/Entry/JobSearch/JobSearchPage.vue'),
  },
  {
    path: '/:studioSlug',
    children: [
      {
        path: 'code/:code?',
        name: AUTO_STUDIO_ACCESS_CODE,
        component: () => import('./pages/Entry/JobSearch/JobSearchPage.vue'),
      },
      {
        path: ':jobId/unavailable',
        name: JOB_UNAVAILABLE,
        component: () => import('./pages/UnavailablePage.vue'),
      },
      {
        path: 'review/:token',
        name: CONSUMER_REVIEW_LINK,
        component: () => import('./pages/ConsumerReviewLinkPage.vue'),
      },
    ],
  },
  {
    path: ':jobId',
    children: [
      {
        path: 'search',
        alias: '/:studioSlug/:jobId',
        name: SUBJECT_SEARCH,
        component: () => import('./pages/Entry/SubjectSearch/SubjectSearchPage.vue'),
        beforeEnter: [jobIsAvailableRouteGuard],
      },
      {
        path: 'select-subject',
        component: () => import('./pages/SubjectsGallery/SubjectsGalleryPage.vue'),
        name: SUBJECTS_GALLERY,
        beforeEnter: [jobIsAvailableRouteGuard],
      },
      {
        // Consumer-derived galleries start here instead of the subject picker: the consumer's own
        // people, not the studio's roster. SubjectsGalleryPage redirects into this flow, so every
        // existing route back to the gallery lands here for these jobs.
        path: 'who',
        name: CONSUMER_GALLERY_ROSTER,
        component: () => import('./pages/ConsumerGallery/ConsumerRosterPage.vue'),
        beforeEnter: [jobIsAvailableRouteGuard],
      },
      {
        path: 'who/new',
        name: CONSUMER_GALLERY_NEW_SUBJECT,
        component: () => import('./pages/ConsumerGallery/ConsumerCreateSubjectPage.vue'),
        beforeEnter: [jobIsAvailableRouteGuard],
      },
      {
        name: CONFIRM_CART,
        path: 'confirmCart',
        component: () => import('./pages/ConfirmCartPage.vue'),
      },
    ],
  },
];

export const digitalRoute: RouteRecordRaw[] = [
  {
    name: DIGITAL_DOWNLOAD,
    //I like having job id but may need to consider forwarding links
    //path: ':jobId/download/:linkId',
    path: 'download/:linkId',
    component: () => import('./pages/DigitalDownloadPage.vue'),
  },
];
